/** @format */
import { css } from 'styled-components';

import { mobile } from '@toucan/client/global/application';

const baseStyles = () => css`
    display: flex;
    margin-top: var(--layout-spacing-16);

    > div {
        display: flex;
        flex-grow: 1;
        align-items: center;
        text-align: left;
    }
    .heading {
        width: 100%;
        flex-grow: 1;
    }

    .action {
        flex-shrink: 0;
        margin-left: var(--layout-spacing-12);
    }

    ${mobile(css`
        > div {
            flex-direction: column;
            align-items: flex-start;
        }

        .action {
            margin-top: var(--layout-spacing-12);
            margin-left: 0;
        }
    `)}
`;

export const styles = () => css`
    ${baseStyles()}
`;
